import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  ElementRef,
} from "@angular/core";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { VAIconRegistryService, close } from "@va/core-library/icons";
import { NzModalRef } from "ng-zorro-antd/modal";

@Component({
  selector: "app-common-modal",
  templateUrl: "./common-modal.component.html",
  styleUrls: ["./common-modal.component.scss"],
  host: { class: "common-modal-component" },
  encapsulation: ViewEncapsulation.None,
})
export class CommonModalComponent implements OnInit {
  @Input() accentColor: string;
  @Input() icon: IconDefinition;
  @Input() title: string;
  @Input() body: string;
  @Input() actionPrimaryText: string;
  @Input() actionSecondaryText: string;
  @Input() actionthirdText: string;
  @Input() onPrimaryClick: Function;
  @Input() onSecondaryClick: Function;
  @Input() onThirdClick: Function;
  @Input() onCancel: Function;

  constructor(
    private modal: NzModalRef,
    private elementRef: ElementRef,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([close]);
  }

  ngOnInit() {
    //define this css variable so that it can be picked up by any
    //html element needing acces to accentColor
    this.elementRef.nativeElement.style.setProperty(
      "--accent-color",
      this.accentColor,
    );
  }

  destroyModal() {
    this.modal.destroy();
    if (typeof this.onCancel === "function") {
      this.onCancel();
    }
  }
}
